import { isEmpty } from 'lodash'

import components from '../../components'

import helpersPdf from '../helpers'
import { ratio } from '../../helpers'
import { PADDING, GAP, defaultColumStyles } from '../../constants'

import palette from 'theme/palette'

const generalInformation = async ({
  pdf,
  date,
  customThemeStatus,
  departmentData,
  stats,
}) => {
  pdf.addPage('a4', 'p')
  components.subtitle(pdf, 'Treinamentos', GAP)

  const headerStyles = {
    textColor: palette.white,
    font: 'Roboto-Bold',
    fillColor: palette.primary.main,
    cellPadding: 6,
  }

  const subtableHeadStyle = {
    textColor: palette.white,
    font: 'Roboto-Bold',
    fillColor: palette.secondary.main,
    cellPadding: 6,
  }

  components.rectangle(
    pdf,
    PADDING,
    GAP * 1.25,
    ratio(470),
    palette.primary.main,
    ratio,
    'Total de Colaboradores',
    stats?.totalUsers || 0,
  )

  components.rectangle(
    pdf,
    PADDING * 1.1 + ratio(470),
    GAP * 1.25,
    ratio(470),
    palette.primary.main,
    ratio,
    '100% Concluídos',
    stats?.completedTrainings || 0,
  )

  components.rectangle(
    pdf,
    PADDING * 1.2 + 2 * ratio(470),
    GAP * 1.25,
    ratio(470),
    palette.primary.main,
    ratio,
    'Com Pendências',
    stats?.pendingTrainings || 0,
  )

  departmentData.forEach((department, index) => {
    let startY = index === 0 ? GAP * 2.75 : pdf.autoTable.previous.finalY + 16

    components.lineWithDate(pdf, date)

    components.table(
      pdf,
      [[department.name]],
      null,
      startY,
      0.5,
      PADDING,
      true,
      defaultColumStyles(0.5, pdf),
      headerStyles,
      13,
    )

    if (isEmpty(department.users)) {
      components.table(
        pdf,
        [['Departamento sem usuários']],
        [],
        pdf.autoTable.previous.finalY,
        0.5,
        PADDING,
        true,
        defaultColumStyles(0.5, pdf),
        subtableHeadStyle,
      )
    } else {
      department.users.forEach((user) => {
        components.table(
          pdf,
          [[user?.name, helpersPdf.userCertificationStatus(user)]],
          helpersPdf.mountUserRow(user),
          pdf.autoTable.previous.finalY,
          0.5,
          PADDING,
          true,
          defaultColumStyles(0.5, pdf),
          subtableHeadStyle,
        )
      })

      components.numberPage(pdf, palette.primary.main, customThemeStatus)
    }
  })
}

export default generalInformation
